// src/redux/actions/companySizeActions.js

import axios from '../../API/axios';
import {
    FETCH_COMPANY_SIZE_REQUEST,
    FETCH_COMPANY_SIZE_SUCCESS,
    FETCH_COMPANY_SIZE_FAILURE,
    SET_SELECTED_COMPANY_SIZE,
} from '../types';

// Action to fetch company size data
export const fetchCompanySizeData = () => async (dispatch) => {
    dispatch({ type: FETCH_COMPANY_SIZE_REQUEST });
    try {
        const response = await axios.get('/MasterDDL/GetFirmSizeDDL');
        console.log('Company Size Response:', response);

        let companySizes = response.data.responseData.map((val) => {
            return { value: val.id, label: val.name }
        })

        dispatch({
            type: FETCH_COMPANY_SIZE_SUCCESS,
            payload: companySizes,
        });
    } catch (error) {
        dispatch({
            type: FETCH_COMPANY_SIZE_FAILURE,
            payload: error.message,
        });
    }
};

// Action to select a specific company size
export const selectCompanySize = (sizeId) => ({
    type: SET_SELECTED_COMPANY_SIZE,
    payload: sizeId,
});
